import React, { FC, ReactNode, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Icons } from '@cld/icon';
import { ToggleableSection } from '@cld/widget-demos-common';
import { updateOptions } from '../../../actions';
import { STEPS } from '../../../constants/general';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { useOptions, useWidget } from '../../../selectors';
import { goToFirstAvailableStep } from '../../../services/widget-service';
import { StepName } from '../../../types';
import { toggleAndKeepOne } from '../../../utils';

export interface StepSectionProps {
  step: StepName,
  title: string,
  children?: ReactNode;
}

const stepToIcon: Record<StepName, Icons> = {
  resizeAndCrop: 'crop',
  imageOverlay: 'layers',
  textOverlays: 'text',
  export: 'fileDownload',
};

export const StepSection: FC<StepSectionProps> = ({ step, title, children }) => {
  const analytics = useAnalytics();
  const { activeSteps } = useOptions();
  const widget = useWidget();
  const dispatch = useDispatch();

  const handleToggle = useCallback((newState: boolean) => {
    analytics('show-hide', `${newState ? 'open' : 'close'} ${step} step`);

    dispatch(updateOptions({
      activeSteps: toggleAndKeepOne(activeSteps, step, true, STEPS[0], STEPS[1]),
    }));

    goToFirstAvailableStep(widget.instance);
  }, [analytics, dispatch, activeSteps, step, widget.instance]);

  return (
    <ToggleableSection title={title} active={activeSteps[step]} icon={stepToIcon[step]} onToggle={handleToggle}>
      {children}
    </ToggleableSection>
  );
};
